import React from "react";
import ShieldLogo from "../../../../assets/shield-round.svg";
import SpectralLogo from "../../../../assets/spectral.svg";
import {
  DialogSteps,
  useDialogStepsContext,
} from "../../../../contexts/DialogStepsContext";
import { Accordion } from "../../../Accordion";
import { RightArrowIcon } from "../../../Icon/icons/RightArrow";
import { OverlapLogos } from "../../../OverlapLogos";
import { SpectralButton } from "../../../SpectralButton";
import { SPECTRAL_QUESTIONS } from "./constants";
import * as SC from "./Faq.styles";

export const Faq = () => {
  const { setCurrentStep } = useDialogStepsContext();
  return (
    <SC.FaqContainer>
      <SC.FaqInformation>
        <div>
          <OverlapLogos topImage={SpectralLogo} backImage={ShieldLogo} />
        </div>
        <h1>Spectral Security FAQ</h1>
        <span>
          Making sure you feel safe when interacting with Spectral is our
          highest priority. We{"’"}ve prepared an FAQ list that should clarify
          any doubts you might have in order to feel completely safe.
        </span>
      </SC.FaqInformation>

      <SC.FaqList>
        {SPECTRAL_QUESTIONS.map((question) => (
          <Accordion
            key={question.question}
            answer={question.answer}
            question={question.question}
          />
        ))}
      </SC.FaqList>

      <SC.ContinueButtonWrapper width="100%" align="end" justify="end">
        <SpectralButton
          width="156px"
          height="56px"
          label={
            <>
              Continue <RightArrowIcon color="var(--white)" />
            </>
          }
          onClick={() => setCurrentStep(DialogSteps.ONBOARDING)}
        />
      </SC.ContinueButtonWrapper>
    </SC.FaqContainer>
  );
};
